import { useId } from "react";

export default function NavbarSuarteworldIcon({ className = "", onClick = null }) {
  const gradientId = useId();

  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0%" stopColor="#FFB500" />
          <stop offset="50%" stopColor="#FF3B58" />
          <stop offset="100%" stopColor="#D000C5" />
        </linearGradient>
      </defs>
      <path
        d="M376.82,135.28c-2.33.17-4.68.35-7.08.57-.34-.36-.7-.73-1.05-1.11-15.31-16.06-34.11-29.33-55.88-38.5-84.82-35.75-182.59,4.03-218.35,88.87-9.43,22.38-13.59,45.62-13.07,68.42,0,.27,0,.54.02.82-.94.78-1.85,1.55-2.76,2.29-36.22,30.74-54.39,60.78-45.63,82.32,9.07,22.28,45.12,30.95,95.09,26.67,15.19,15.79,33.75,28.78,55.21,37.83,84.84,35.75,182.6-4.05,218.35-88.87,8.89-21.08,13.11-42.98,13.12-64.52,40.55-32.59,61.45-64.91,52.17-87.73-8.77-21.54-42.75-30.35-90.14-27.06ZM424.19,168.87c2.63,2.48,4.63,5.31,5.91,8.47,5.14,12.63-1.59,29.06-17.32,46.8-25.9,29.18-76.21,61.9-138.11,87.1-63.94,26.02-124.63,37.67-163.46,33.79-21.6-2.14-36.46-9.11-41.32-21.07-1.29-3.17-1.83-6.58-1.68-10.2.44-9.84,6.1-21.16,16.05-33.14,3.02,16.15,8.45,31.77,16.02,46.31,38.95,5.87,101.73-5.09,167.77-31.97,63.99-26.05,115.41-60.68,140.14-91.39-4.86-16.9-12.4-32.97-22.34-47.55,17.31,1.34,30.59,5.59,38.34,12.85Z"
        style={{ fill: `url(#${gradientId})`, stroke: `url(#${gradientId})` }}
      />
    </svg>
  );
}
